import { useAuth } from '../contexts/AuthContext'
import { useOrganization } from '../contexts/OrganizationContext'
import { KNOWN_ORGS } from '../config/organizations'

// Simple user type system without database table
// Maps user_type codes to themes and features

const DEFAULT_CONFIG = {
  code: 'default_admin',
  organizationId: KNOWN_ORGS.DEFAULT,
  role: 'admin',
  displayName: 'Administrator',
  theme: {
    primary: '#9CA3AF',
    secondary: '#000000',
    accent: '#FFFFFF',
    background: '#0F0F0F',
    text: '#FFFFFF',
    mode: 'dark' as const,
    sidebar: {
      bg: '#1a1a1a',
      text: '#9CA3AF',
      hover: '#FFFFFF'
    },
    header: {
      bg: '#000000',
      text: '#9CA3AF'
    }
  },
  branding: {
    name: 'Facility Manager',
    shortName: 'FM',
    logo: '',
    tagline: 'Smart Facility Management'
  },
  dashboard: 'facility_admin',
  modules: {
    ice_rental: true,
    leagues: true,
    pro_shop: true,
    camps: true,
    invoicing: true,
    reporting: true
  } as Record<string, boolean>
}

export function useUserTypeSimple() {
  // Hooks must be called unconditionally at the top level (React Rules of Hooks)
  const authContext = useAuth()
  const orgContext = useOrganization()

  // Defensive: Safely extract values with null checks
  const profile = authContext?.profile ?? null
  const user = authContext?.user ?? null
  const organization = orgContext?.organization ?? null

  // Always use default config - organization-specific theming comes from database settings
  const config = DEFAULT_CONFIG

  return {
    userType: config.code,
    organizationId: organization?.id || config.organizationId,
    role: config.role,
    displayName: config.displayName,
    theme: config.theme,
    branding: config.branding,
    dashboard: config.dashboard,
    modules: config.modules,
    hasModule: (moduleName: string) => config.modules[moduleName] === true
  }
}
